module.exports = __webpack_public_path__ + "img/ico223.3d552282.svg";